$(document).ready(function () {
    var inputData = $('#inputData');
    var banksAndCardsArray = $('.card-and-bank-option');
    var cardOptions = $('.card-option');
    var otrosBancosOption = $('[data-bank="global"]');
    var selectedCardB = $('#selectedCardB');
    var selectedBankB = $('#selectedBankB');
    var cardNameMapping = {
        visa: 'Visa',
        mastercard: 'Mastercard',
        cabal: 'Cabal',
        amex: 'American Express',
        naranja: 'Tarjeta Naranja'
    };
    var bankNameMapping = {
        provincia: 'Banco Provincia',
        bancogalicia: 'Banco Galicia',
        bancopatagonia: 'Banco Patagonia',
        credicoop: 'Banco Credicoop',
        icbc: 'ICBC',
        cencosud: 'Cencosud',
        bancodeneuquen: 'Banco de Neuquen',
        bancodeformosa: 'Banco de Formosa',
        bancodelchaco: 'Banco del Chaco',
        bancomunicipalidadderosario: 'Banco Municipalidad de Rosario',
        ciudad: 'Banco Ciudad',
        macro: 'Macro',
        bancocomafi: 'Banco Comafi',
        bancodecordoba: 'BANCOR',
        bancocordoba: 'BANCOR',
        bancosupervielle: "Banco Superville",
        santanderrio: 'Santander Rio',
        hsbc: 'HSBC',
        naranja: 'Naranja',
        bancosol: "Banco del Sol",
        amexpropias: 'Amex',
        global: 'Otros Bancos'
    };

    function createPromotionsStructure(promotions) {
        var promotionsContainer = $('.promo-data-desktop');
        promotionsContainer.empty();
        if (promotions.selectedBankPromotion) {
            promotions.selectedBankPromotion.forEach(function (promotion) {
                var promotionRowDesktop = `
                    <div class="row promotions-container promotions-container-desktop">
                    <span class="col-12 col-md-2">${promotion.label}</span>
                    <span class="col-12 col-md-2 installment-value">$${promotion.installmentValue}</span>
                    <span class="col-12 col-md-2">$${promotion.totalPrice}</span>
                    <span class="col-12 col-md-2">$${promotion.installmentInterest}</span>
                    <span class="col-12 col-md-2">${promotion.cft}%</span>
                    <span class="col-12 col-md-2">${promotion.TEA}%</span>
                    </div>
                `;
                promotionsContainer.append(promotionRowDesktop);
            });
        }
        if (promotions.selectedBankPromotion) {
            promotions.selectedBankPromotion.forEach(function (promotion) {
                var promotionRowMobile = `
                    <div class="row promotions-container promotions-container-mobile">
                    <span class="col-12 col-md-2">${promotion.label} de <span class="col-12 col-md-2 installment-value">$${promotion.installmentValue}</span></span>
                    <span class="col-12 col-md-2">Total financiado $${promotion.totalPrice}</span>
                    <span class="col-12 col-md-2">Intereses $${promotion.installmentInterest}</span>
                    <span class="col-12 col-md-2">CFT<sup>1</sup> ${promotion.cft}%</span>
                    <span class="col-12 col-md-2">TEA<sup>2</sup> ${promotion.TEA}%</span>
                    </div>
                `;
                promotionsContainer.append(promotionRowMobile);
            });
        }
    }
    banksAndCardsArray.each(function () {
        $(this).on('click', function () {
            var bankData = this.dataset.bank;
            inputData[0].dataset.bank = bankData;
            selectedCardB.empty();
            selectedBankB.empty();
            selectedCardB.append(cardNameMapping[inputData[0].dataset.card]);
            selectedBankB.append(bankNameMapping[inputData[0].dataset.bank]);
            var data = {
                selectedBank: inputData[0].dataset.bank,
                selectedCard: inputData[0].dataset.card,
                currentProductId: inputData[0].dataset.productid
            };
            $.ajax({
                url: $(this).attr('data-action-url'),
                data: data,
                success: function (d) {
                    createPromotionsStructure(d);
                },
                error: function (err) {
                    console.log(err);
                }
            });
        });
    });

    cardOptions.on('click', function () {
        cardOptions.removeClass('selected');
        $(this).addClass('selected');
    });
    var bankOptions = $('.card-and-bank-option');
    bankOptions.on('click', function () {
        bankOptions.removeClass('selected');
        $(this).addClass('selected');
    });

    cardOptions.on('click', function () {
        var cardData = this.dataset.card;
        inputData[0].dataset.card = cardData;
        for (let i = 0; i < banksAndCardsArray.length; i++) {
            if (banksAndCardsArray[i].dataset.bank !== 'global') {
                banksAndCardsArray[i].style.display = 'none';
            }
            if (banksAndCardsArray[i].dataset.card === cardData) {
                banksAndCardsArray[i].style.display = 'block';
            }
        }
        var firstVisibleBank = $('.col-promotion-banks .row img').filter(':visible').first();
        if (cardData === 'amex' || cardData === 'cabal') {
            $('[data-bank="global"]').hide();
            firstVisibleBank.trigger('click');
        } else {
            $('[data-bank="global"]').show();
            otrosBancosOption.trigger('click');
        }
    });

    $('#bankPromotions').on('shown.bs.modal', function () {
        cardOptions.first().click();
        otrosBancosOption.click();
    });
});
